module.exports = __webpack_public_path__ + "img/bg09.96c82009.gif";